import { render, staticRenderFns } from "./InspectionScore.vue?vue&type=template&id=6f617de2"
import script from "./InspectionScore.vue?vue&type=script&lang=js"
export * from "./InspectionScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports